module.exports = __webpack_public_path__ + "static/media/SINDROME.d60f1098.png";